import type { OwnedAccount } from '@hotjar/account';
import { isAccountAllowed } from '../common/feature';
import { getLocalOverride } from '../common/feature/local-override';

export enum FeatureBilling {
  zuora = 'billing_zuora',
  billingV3 = 'billing_v3',
}

/**
 *
 * @deprecated use isBillingV3Enabled instead
 */
export const isZuoraEnabled = (
  account: Pick<OwnedAccount, 'id' | 'features'> | undefined,
): boolean => {
  if (!account) {
    return false;
  }

  if (getLocalOverride(FeatureBilling.billingV3)) {
    return true;
  }

  return (
    isAccountAllowed(FeatureBilling.zuora, {
      id: account.id,
      features: account.features,
    }) ||
    isAccountAllowed(FeatureBilling.billingV3, {
      id: account.id,
      features: account.features,
    })
  );
};

export const isBillingV3Enabled = (
  account: Pick<OwnedAccount, 'id' | 'features'> | undefined,
): boolean => {
  if (!account) {
    return false;
  }

  return (
    getLocalOverride(FeatureBilling.billingV3) ||
    isAccountAllowed(FeatureBilling.billingV3, {
      id: account.id,
      features: account.features,
    })
  );
};
